import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Tabs from "src/componets/Tabs";

import { AppleOutlined, AndroidOutlined } from "@ant-design/icons";
import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import { ButtonEdit } from "src/componets/Buttons";

import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectBundleById, setEditId } from "src/store/gh_market/bundlesSlice";
import { fetchBundle } from "src/actions/gh_market/bundlesActions";
import { fetchProducts } from "src/actions/gh_market/productsActions";

import Edit from "./Edit";
import SidebarShow from "./_partials/_SidebarShow";
import Products from "./_partials/_Products";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const bundle = useAppSelector(state => selectBundleById(state, id as any));

  useEffect(() => {
    if (id) {
      dispatch(fetchBundle(id));
      dispatch(fetchProducts({ bundle_id: id }));
    }
  }, [id, dispatch]);

  const items = [
    {
      label: 'Products',
      key: 'products',
      children: <Products bundle={bundle} />,
    },
  ];

  return (
    <PageLayout>
      <div className='v-container-fluid'>
        <SummaryShow
          title={bundle?.name}
          icon={bundle?.platform === 'ios' ? <AppleOutlined /> : <AndroidOutlined />}
          createdAt={bundle?.created_at || ''}
          updatedAt={bundle?.updated_at || ''}
          actions={[
            <ButtonEdit key='edit' onClick={() => dispatch(setEditId(bundle?.id))} />
          ]}
        />

        <Tabs items={items} />
      </div>

      <Edit />
      <SidebarShow bundle={bundle} />
    </PageLayout>
  );
}

export default Show;
